const RetinaImg = ({ src, alt = '', ...props }) => {
  const getRetinaSrc = (path) => {
    return path.replace(/(\.\w+)$/, '@2x$1');
  };

  const retinaSrc = getRetinaSrc(src);

  return <img src={src} srcSet={`${src} 1x, ${retinaSrc} 2x`} alt={alt} {...props} />;
};

export default RetinaImg;
